<template>
  <div class="ap-field">
    <label :for="inputId">{{ label }} <span v-if="required" class="ap-req">*</span></label>
    <div class="ap-input-wrap">
      <fa-icon :icon="['fas', 'lock']" class="ap-lead" />
      <input
        :id="inputId"
        :value="value"
        :type="visible ? 'text' : 'password'"
        :placeholder="placeholder"
        :autocomplete="autocomplete"
        class="ap-input pi-input"
        :class="{ 'has-error': value && !isValid }"
        @input="$emit('input', $event.target.value)"
      />
      <button class="pi-eye" type="button" tabindex="-1" @click="visible = !visible">
        <fa-icon :icon="['fas', visible ? 'eye-slash' : 'eye']" />
      </button>
    </div>
    <span v-if="value && !isValid" class="ap-err">
      <fa-icon :icon="['fas', 'exclamation-circle']" /> {{ errorMessage }}
    </span>
    <span v-if="hint" class="ap-hint">{{ hint }}</span>
  </div>
</template>

<script>
export default {
  name: 'PasswordInput',
  props: {
    value: { type: String, default: '' },
    label: { type: String, default: 'Password' },
    required: { type: Boolean, default: false },
    placeholder: { type: String, default: '' },
    hint: { type: String, default: '' },
    inputId: { type: String, default: '' },
    minLength: { type: Number, default: 0 },
    matchValue: { type: String, default: null },
    autocomplete: { type: String, default: 'new-password' }
  },
  data () {
    return { visible: false }
  },
  computed: {
    isValid () {
      if (this.matchValue !== null) return this.value === this.matchValue
      if (this.minLength > 0) return this.value.length >= this.minLength
      return true
    },
    errorMessage () {
      if (this.matchValue !== null) return 'Passwords do not match.'
      if (this.minLength > 0) return `Must be at least ${this.minLength} characters.`
      return ''
    }
  }
}
</script>
